"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanAdministrationPermissions = void 0;
var constants_1 = require("@hobt/constants");
/*
 * For ITM, Property Repair, Underwriting Review.  Can separate these out later if required.
 */
exports.LoanAdministrationPermissions = {
    Create: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
    Delete: {
        modules: [constants_1.Module.Claim],
        roles: [
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
        ],
    },
    Read: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    Update: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
};
